export default __webpack_public_path__ + "static/media/dev.2880fc8e.svg";